var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63965 10.8879C3.63965 9.92144 4.42315 9.13794 5.38965 9.13794H52.0563C53.0228 9.13794 53.8063 9.92144 53.8063 10.8879V28.3879C53.8063 29.3544 53.0228 30.1379 52.0563 30.1379C51.0898 30.1379 50.3063 29.3544 50.3063 28.3879V12.6379H7.13965V44.1379H28.723C29.6895 44.1379 30.473 44.9214 30.473 45.8879C30.473 46.8544 29.6895 47.6379 28.723 47.6379H5.38965C4.42315 47.6379 3.63965 46.8544 3.63965 45.8879V10.8879Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.973 40.0546C33.973 39.0881 34.7565 38.3046 35.723 38.3046H52.0563C53.0228 38.3046 53.8063 39.0881 53.8063 40.0546C53.8063 41.0211 53.0228 41.8046 52.0563 41.8046H35.723C34.7565 41.8046 33.973 41.0211 33.973 40.0546Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9855 32.9838C45.669 32.3004 46.777 32.3004 47.4604 32.9838L53.2938 38.8172C53.9772 39.5006 53.9772 40.6086 53.2938 41.292L47.4604 47.1254C46.777 47.8088 45.669 47.8088 44.9855 47.1254C44.3021 46.442 44.3021 45.3339 44.9855 44.6505L49.5814 40.0546L44.9855 35.4587C44.3021 34.7753 44.3021 33.6673 44.9855 32.9838Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.98975 9.83804C4.56965 9.06484 5.66655 8.90814 6.43975 9.48804L28.7231 26.2005L51.0064 9.48804C51.7796 8.90814 52.8765 9.06484 53.4564 9.83804C54.0363 10.6112 53.8796 11.7081 53.1064 12.288L29.7731 29.788C29.1509 30.2547 28.2953 30.2547 27.6731 29.788L4.33975 12.288C3.56655 11.7081 3.40985 10.6112 3.98975 9.83804Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/send-email.58fe7ffd.svg";
export { ForwardRef as ReactComponent };